import { createSlice } from '@reduxjs/toolkit'

const initValues = {
  isSaving: false,
  errorMsg: null,
  test: false,
  commerces: [],
  banks: [
    {
      account_description: 'Test',
      account_name: 'Ahorros',
      account_number: '01050019210019834411',
      account_type: 'savings',
      bank_code: '0105',
      bank_name: 'Banco Mercantil',
      currency: 'BS',
      doc_id: '22903289',
      doc_type: 'V',
      last_name: 'Izquierdo',
      name: 'Pablo',
      phone: '0424123456',
      _id: '63516870e4122753384ac23e'
    }
  ]
}

export const withdrawSlice = createSlice({
  name: 'appInvoice',
  initialState: initValues,
  reducers: {
    withdrawFounds: (state) => {
      state.isSaving = false
    },
    loadCommerces: (state, action) => {
      state.commerces = action.payload
    },

    setErrorMsg: (state, action) => {
      state.errorMsg = action.payload
    }
  }
})

export const { withdrawFounds, loadCommerces, setErrorMsg } =
  withdrawSlice.actions

export const withdraw = withdrawSlice.reducer
